import React from "react";
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";

const BreadcrumbComponent = () => {
  const location = useLocation();
  const path = location.pathname;

  const pathSegments = path.split("/").filter(Boolean);

  return (
    <Breadcrumb className="pt-4 pb-4 z-50">
      <Link to="/">
        <BreadcrumbItem icon={HiHome}>Home</BreadcrumbItem>
      </Link>

      {pathSegments.map((segment, index) => {
        const href = "/" + pathSegments.slice(0, index + 1).join("/");

        // Capitalize the segment
        const label = segment.charAt(0).toUpperCase() + segment.slice(1);

        return (
          <BreadcrumbItem key={href}>
            {index === pathSegments.length - 1 ? (
              <span>{label}</span>
            ) : (
              <Link to={href}>{label}</Link>
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadcrumbComponent;
